<template>
  <div class="header">
    <div class="top">
      <div class="left"></div>
      <div class="right">
        <div class="user">
          <span class="user-icon"></span>
          <span> 您好！</span>
          <span
            style="color: #303133"
            v-if="
              this.$route.path == '/register/phone' || this.$route.path == '/register/applytrial'
            "
          >
            已有账号？
          </span>
          <span
            class="user-name"
            :class="descText === (this.userInfo && this.userInfo.name) ? 'user-name' : 'login-btn'"
            @click="handleClick"
          >
            {{ descText }}
          </span>
        </div>
        <div class="logout" v-if="$route.path === '/register/systemselect'" @click="handleLogout">
          <el-tooltip class="item" effect="dark" content="退出" placement="top">
            <i class="el-icon-switch-button"></i>
          </el-tooltip>
        </div>
      </div>
    </div>
    <div class="bottom" v-if="$route.path !== '/register/systemselect'">{{ title }}</div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import commonApi from '@/api/common.js';
// import loginApi from 'api/login.js';
// import store from 'utils/store.js';

export default {
  props: {},
  data() {
    return {
      platformName: '智慧园区环保管理平台',
      platformLogo: ''
    };
  },
  computed: {
    ...mapGetters(['userInfo']),

    title() {
      // const title = (this.userInfo && this.userInfo.appList[0].orgName) || '子系统选择';
      switch (this.$route.path) {
        // case '/register/systemselect':
        //   return title;
        case '/register/phone':
          return '注册账号';
        case '/register/applytrial':
          return '申请试用';
        case '/register/findpassword':
          return '忘记密码';
        default:
          return '';
      }
    },
    descText() {
      switch (this.$route.path) {
        case '/register/systemselect':
          return this.userInfo && this.userInfo.name;
        case '/register/phone':
          return '请登录';
        case '/register/applytrial':
          return '请登录';
        case '/register/findpassword':
          return '返回';
        default:
          return '';
      }
    }
  },
  created() {
    // this.getTitle();
  },
  methods: {
    ...mapActions(['logout']),
    getTitle() {
      commonApi
        .getDictType('platform_config')
        .then(res => {
          if (res.data.code !== 200) {
            return;
          }
          const platformInfoList = res.data.data;
          platformInfoList.forEach(item => {
            if (item.code === 'platform_logo') {
              this.platformLogo = item.value;
            } else if (item.code === 'platform_name') {
              this.platformName = item.value;
            }
          });
        })
        .catch(err => {
          console.log(err);
        });
    },
    handleClick() {
      // debugger
      if (this.descText === (this.userInfo && this.userInfo.name)) {
        return;
      } else {
        this.$router.push('/login');
      }
    },
    handleLogout() {
      this.logout().then(() => {
        this.$message({
          message: '安全退出',
          type: 'success'
        });
        this.$router.replace('/login');
      });
    }
  }
};
</script>

<style lang="less" scoped>
.header {
  .top {
    padding-left: 20px;
    height: 64px;
    background-color: rgba(255, 255, 255, 0.5);
    // opacity: 0.5;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .left {
      background: url('~assets/images/logo_fushunheader.png') no-repeat;
      font-size: 24px;
      // color: #303133;
      width: 438px;
      height: 64px;
    }

    .right {
      display: flex;
      justify-content: space-between;
      height: 24px;
      line-height: 24px;
      font-size: 14px;
      color: #303133;

      .user {
        display: flex;
        padding-right: 16px;
        .user-icon {
          display: inline-block;
          box-sizing: border-box;
          width: 24px;
          height: 24px;
          margin-right: 8px;
          background: url('~assets/images/组 6230.png') no-repeat;
        }
        .login-btn {
          color: #409dff;
          cursor: pointer;
        }
        .user-name {
          font-weight: bolder;
          color: #409dff;
        }
      }

      .logout {
        border-left: 2px solid #90939b;
        padding: 0 16px;
        font-size: 24px;
        color: #303133;
        font-weight: 700;
        cursor: pointer;
      }
    }
  }
  .bottom {
    background-color: #409dff;
    font-size: 24px;
    color: #fff;
    line-height: 64px;
    text-align: center;
  }
}
</style>
